import React from "react";
import "./Footer.css";
import {
  FaPhone,
  FaMobileAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  // FaGlobe,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import Google from "./images/googlefooter.png";
import Facebook from "./images/facebookfooter.png";
import Bing from "./images/bingfooter.png";
import justdial from './images/justdial.jpeg'
import Iso from "./images/isofooter.png";
import Whatsapp from '../Whatsapp/Whatsapp'
import InternshipButton from "../Internship Button/InternshipButton";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {

  const messages = [
    // Web Development Content
    "Custom Web Development",
    "Responsive Design",
    "React & Next.js Experts",
    "Node.js Backend Solutions",
    "E-Commerce Development",
    "Angular Solutions",
    "Node.js Development",
    "Express.js APIs",
    "PHP/Laravel Solutions",
    "Single Page Applications",
    "Payment Gateway Integration",
  
    // DevOps & Cloud
    "AWS Architecture",
    "Azure Cloud Solutions",
    "Google Cloud Services",
    "Docker & Kubernetes",
    "CI/CD Pipelines",
    "Web3 Development",
  
    // Company & General
    "Digital Transformation",
    "Web Performance Optimization",
    "UI/UX Design Excellence",
    "Cloud Solutions",
    "API Integration",
    "Progressive Web Apps",
    "CMS Development",
    "Web Security Solutions",
    "Database Optimization",
  ];
  
  const messagestwo = [
    "Technology Practices",
    "Digital Marketing",
    "Software Product",
    "Cloud & Infrastructure",
    "DevSecOps",
    "Digital Quality Assurance",
    "Offerings",
    "Generative AI",
    "CX Infrastructure",
    "Intelligent Automation",
    "Application Development & Management",
    "Training",
    "Private Equity",
    "Private Equity Services",
    "Enterprise Integrations",
    "Enterprise IT Security",
    "Data and Analytics",
    "Mobile",
  ];


  return (
    <footer className="footer-container">

    <InternshipButton/>

    <div className="marquee-section">
        <h2 className="marquee-heading">
          <span>Expert's in Web Development</span>
        </h2>

        <div className="marquee-container">
          <div className="marquee-content">
            {/* First set of messages */}
            {messages.map((message, index) => (
              <div key={`first-${index}`} className="marquee-item">
                <span className="marquee-text">{message}</span>
                <span className="marquee-icon">@</span>
              </div>
            ))}

            {/* Duplicate set for seamless looping */}
            {messages.map((message, index) => (
              <div key={`second-${index}`} className="marquee-item">
                <span className="marquee-text">{message}</span>
                <span className="marquee-icon">@</span>
              </div>
            ))}
          </div>

          <div className="marquee-wrapper">
            {/* <h2 className="services-heading">Our Services</h2> */}

            <div className="marquee-container">
              <div className="marquee-content">
                {/* First set of messages */}
                {messagestwo.map((message, index) => (
                  <div key={`first-${index}`} className="marquee-item">
                    <span className="marquee-text">{message}</span>
                    <span className="marquee-icon">@</span>
                  </div>
                ))}

                {/* Duplicate set for seamless looping */}
                {messagestwo.map((message, index) => (
                  <div key={`second-${index}`} className="marquee-item">
                    <span className="marquee-text">{message}</span>
                    <span className="marquee-icon">@</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    <Whatsapp/>
      <div className="footer-grid">
        {/* Column 1 - Navigation Links */}
        <div className="footer-column">
          <h3 className="column-heading">Industries</h3>
          <ul className="footer-links">
            <li>
              <a href="/fintech">Fintech</a>
            </li>
            <li>
              <a href="/real-estate">Real Estate</a>
            </li>
            <li>
              <a href="/banking">Banking</a>
            </li>
            <li>
              <a href="/pharma">Pharma</a>
            </li>
            <li>
              <a href="/health-care">Healthcare</a>
            </li>
            <li>
              <a href="/welfare">Welfare</a>
            </li>
            <li>
              <a href="/art">Art</a>
            </li>
            <li>
              <a href="/insurance">Insurance</a>
            </li>
            <li>
              <a href="/government">Government</a>
            </li>
          </ul>
        </div>

        {/* Column 2 - Navigation Links */}
        <div className="footer-column">
          <h3 className="column-heading">Company</h3>
          <ul className="footer-links">
          <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="/corporate-value">Corporate Value</a>
            </li>
            <li>
              <a href="/send-cv">Send CV</a>
            </li>
            <li>
              <a href="/internship-program">Internship Program</a>
            </li>
            <li>
              <a href="/employee-testimonials">Employee Testimonials</a>
            </li>
            <li>
              <a href="/blog">Blogs</a>
            </li>
            <li>
              <a href="/contact-us">Contact Us</a>
            </li>
            <li>
              <a href="#">Privacy</a>
            </li>
            <li>
              <a href="#">Disclaimer</a>
            </li>
          </ul>
        </div>

        {/* Column 3 - Contact Information */}
        <div className="footer-column">
          <h3 className="column-heading">Customer Care Number</h3>
          <ul className="contact-info">
            <li>
              <FaPhone className="contact-icon" /> +91-2269710459
            </li>
          </ul>

          <h3 className="column-heading">Mobile Number</h3>
          <ul className="contact-info">
            <li>
              <FaMobileAlt className="contact-icon" /> +91-9155599968
            </li>
          </ul>

          <h3 className="column-heading">Customer Support E-Mail</h3>
          <ul className="contact-info">
            <li>
              <FaEnvelope className="contact-icon" /> cs@mketech.in 
            </li>
             <li>
              <FaEnvelope className="contact-icon" /> help@mketech.in 
            </li>
          </ul>
        </div>

        {/* Column 4 - Address */}
        <div className="footer-column address-column">
          <h3 className="column-heading">Corporate Office</h3>
          <address>
            <FaMapMarkerAlt className="contact-icon" />
            B-13, 2nd Floor, Prozone Trade Center, beside Prozone Mall,
            <br />
            MIDC Industrial Area, Chilkalthana,
            <br />
            Chhatrapati Sambhajinagar (Aurangabad),
            <br />
            Maharashtra 431003
          </address>
        </div>

        {/* Social Icons and Certification Images */}
        <div className="footer-social-certification">
          <div className="social-icons-container">
            <a
              href="https://www.facebook.com/MkeTech.Pvt.Ltd/"
              className="social-icon"
              aria-label="Facebook"
              target="_blank"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/mketech_"
              className="social-icon"
              aria-label="Twitter"
              target="_blank"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://www.linkedin.com/company/mk-e-tech-private-limited/posts/?feedView=all"
              className="social-icon"
              aria-label="LinkedIn"
              target="_blank"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/mketech_private_limited/"
              className="social-icon"
              aria-label="Instagram"
              target="_blank"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.youtube.com/@MkeTech."
              className="social-icon"
              aria-label="YouTube"
              target="_blank"
            >
              <FaYoutube />
            </a>
          </div>
          <div className="certification-images">
            <img src={Google} alt="Google Certification" />
            <img src={Facebook} alt="Facebook Certification" />
            <img src={justdial} alt="JustDial" className="justdial"/>
            <img src={Bing} alt="Bing Certification" />
            <img src={Iso} alt="ISO Certification" />
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">
          © Copyright MK e-tech Private Limited | All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;